import { Button, Header, Icon, Segment } from "semantic-ui-react";

import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { db } from "astrid-firebase";
import useCollectionData from "astrid-firestore/src/hooks/useCollectionData";

import Flex from "../../../../components/Flex/Flex";
import LoadingContext from "../../../ui/components/LoadingContext/LoadingContext";

import { useProfile } from "../../../authentication/state/profile";
import useHasRight from "../../../authorization/hooks/useHasRight";
import DiscussionChannelForm from "../../../discussion/components/DiscussionChannelForm/DiscussionChannelForm";
import DiscussionChannelList from "../../../discussion/components/DiscussionChannelList/DiscussionChannelList";

export default function ProductionDiscussionsView({ production }) {
	const { t } = useTranslation();
	const user = useProfile();
	const hasRight = useHasRight();

	const [openCreateDiscussionChannelModal, setOpenCreateDiscussionChannelModal] = useState(false);

	const discussionChannelQuery = hasRight("discussions.manage")
		? db.collection("discussionChannels").where("subject.id", "==", production.id).where("deleted", "==", false)
		: db
				.collection("discussionChannels")
				.where("subject.id", "==", production.id)
				.where("userIds", "array-contains", user.id)
				.where("deleted", "==", false);

	const [discussionChannels, loading, error] = useCollectionData(discussionChannelQuery);

	const sortedDiscussionChannels = discussionChannels?.toSorted((a, b) =>
		!a.lastComment ? 0 : a.lastComment?.created?.toMillis() < b.lastComment?.created?.toMillis() ? 1 : -1,
	);

	return (
		<>
			<LoadingContext loading={loading} error={error}>
				<Header as="h4">{t("discussions", "Discussions")}</Header>

				<Segment style={{ padding: 0 }}>
					<DiscussionChannelList channels={sortedDiscussionChannels} production={production} />

					{hasRight("discussions.manage") && (
						<Flex
							justifyContent="flex-start"
							gap={10}
							onClick={() => setOpenCreateDiscussionChannelModal(true)}
							style={{ padding: 15, cursor: "pointer" }}
						>
							<Button icon circular style={{ height: 40, width: 40 }}>
								<Icon name="plus" />
							</Button>

							{t("createChannel", "Create channel")}
						</Flex>
					)}
				</Segment>
			</LoadingContext>

			{openCreateDiscussionChannelModal && (
				<DiscussionChannelForm
					production={production}
					onClose={() => setOpenCreateDiscussionChannelModal(false)}
				/>
			)}
		</>
	);
}
